import { useState, useEffect } from 'react';
import api from '../services/api';

export default function LegalsPage() {
  const [profile, setProfile] = useState(null)

  useEffect(() => {
      api.get('/api/workspaces/public-profile')
         .then(res => setProfile(res.data))
         .catch(console.error)
  },  [])

  if (!profile) {
      return <div className="min-h-screen flex items-center justify-center"><div className="spinner border-sage-600" /></div>
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-gray-700">
      <h1 className="text-3xl font-serif text-sage-700 mb-8">Mentions Légales & CGV</h1>

      <div className="space-y-8 bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        
        <section>
          <h2 className="text-xl font-bold mb-4 text-sage-600">1. Éditeur du site</h2>
          <p>
            <strong>{profile.admin_name}</strong><br/>
            {profile.admin_title}<br/>
            {profile.cabinet_name}<br/>
            {profile.cabinet_address.replace('\n', ', ')}, {profile.cabinet_city}<br/>
            SIRET : {profile.cabinet_siret}<br/>
            RPPS : {profile.cabinet_rpps}<br/>
            Email : {profile.cabinet_email}<br/>
            Téléphone : {profile.cabinet_phone}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-4 text-sage-600">2. Conditions Générales de Vente (CGV)</h2>
          
          <h3 className="font-bold mt-4 mb-2">Tarifs</h3>
          <p>Les honoraires sont librement fixés et affichés sur le site. Ils ne sont pas remboursés par la Sécurité Sociale mais peuvent être pris en charge par certaines mutuelles.</p>

          <h3 className="font-bold mt-4 mb-2">Paiement</h3>
          <p>Le paiement s'effectue soit au cabinet (espèces, chèque), soit en ligne via notre partenaire sécurisé Stancer (Carte Bancaire) pour les téléconsultations ou les acomptes.</p>

          <h3 className="font-bold mt-4 mb-2">Annulation et Remboursement</h3>
          <p>Tout rendez-vous peut être modifié ou annulé sans frais jusqu'à 48h avant l'heure prévue.</p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li><strong>Annulation &gt; 48h :</strong> Remboursement intégral (100%).</li>
            <li><strong>Annulation entre 24h et 48h :</strong> Une indemnité de 30% du montant sera retenue.</li>
            <li><strong>Annulation &lt; 24h ou Non-présentation :</strong> La séance est due en totalité (pas de remboursement), sauf cas de force majeure justifié.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-4 text-sage-600">3. Données Personnelles</h2>
          <p>
            Les informations recueillies lors de la prise de rendez-vous sont nécessaires à la gestion de votre dossier.
            Elles sont strictement confidentielles et couvertes par le secret médical.
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données: 
            <a href={`mailto:${profile.cabinet_email}`} className="underline hover:text-sage-500 text-xs mt-2 ml-1">
              {profile.cabinet_email}
            </a>
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold mb-4 text-sage-600">4. Hébergement</h2>
          <p>
            Ce site est hébergé sur un serveur privé sécurisé.<br/>
            Responsable technique : BellaBlue SaaS.
          </p>
        </section>
      </div>
    </div>
  );
}
